import React from "react";
import UpgradeButton from "../UpgradeButton";
function Errors({ errors }) {
  return (
    <div>
      {errors.map((error, index) => (
        <p key={index}>
          {error}
          {error.includes("video") && (
            <UpgradeButton
              title="Upgrade Now"
              className="inline-block badge badge--primary sm:text-sm !bg-purple-100 !text-purple-700"
            />
          )}
        </p>
      ))}
    </div>
  );
}
export default Errors;
